module.exports = __webpack_public_path__ + "img/12b.b49984f1.jpg";